export default function Chat(props: any) {
    return (
        <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path d="M16.5 19.5H11V15.5H18V11.5H22V19.5H19.5L18 21L16.5 19.5Z" stroke="black" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M2 3.5H18V15.5H8.5L6.5 17.5L4.5 15.5H2V3.5Z" stroke="black" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M6 11.5H9" stroke="black" strokeWidth="1.3" strokeLinecap="round" />
            <path d="M6 7.5H12" stroke="black" strokeWidth="1.3" strokeLinecap="round" />
        </svg>
    );
}
